import { PATH_CUSTOMER_MOBILE_REGISTER } from "./paths";
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import AuthProtect from 'src/components/Auth/AuthProtect';
import DashboardCustomerMobRegisterLayout from "src/layouts/DashboardCustomerMobRegisterLayout";

// ----------------------------------------------------------------------

const AppCustomerMobileRegisterRoutes = {
  path: PATH_CUSTOMER_MOBILE_REGISTER.root,
  guard: AuthProtect,
  layout: DashboardCustomerMobRegisterLayout,
  routes: [
    // GENERAL
    // ----------------------------------------------------------------------
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE_REGISTER.general.retailerApplicationForm,
      component: lazy(() => import('src/views/CustomerMobileRegisterDashboardGroup/RetailerApplicationForm/RetailerApplicationForm'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE_REGISTER.general.retailerApplicationFormNew.form001,
      component: lazy(() => import('src/views/CustomerMobileRegisterDashboardGroup/RetailerApplicationForm/Form001'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE_REGISTER.general.retailerApplicationFormNew.form002,
      component: lazy(() => import('src/views/CustomerMobileRegisterDashboardGroup/RetailerApplicationForm/Form002'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE_REGISTER.general.retailerApplicationFormNew.form003,
      component: lazy(() => import('src/views/CustomerMobileRegisterDashboardGroup/RetailerApplicationForm/Form003'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE_REGISTER.general.retailerApplicationFormNew.form004,
      component: lazy(() => import('src/views/CustomerMobileRegisterDashboardGroup/RetailerApplicationForm/Form004'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE_REGISTER.general.retailerApplicationFormNew.form005,
      component: lazy(() => import('src/views/CustomerMobileRegisterDashboardGroup/RetailerApplicationForm/Form005'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE_REGISTER.general.retailerApplicationFormNew.formSummary,
      component: lazy(() => import('src/views/CustomerMobileRegisterDashboardGroup/RetailerApplicationForm/FormSummary'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE_REGISTER.general.retailerApplicationFormNew.formAgreement,
      component: lazy(() => import('src/views/CustomerMobileRegisterDashboardGroup/RetailerApplicationForm/FormAgreementTermDistributor'))
    }
  ]
}

export default AppCustomerMobileRegisterRoutes